// extracted by mini-css-extract-plugin
export default {"avatar":"JnV5je","withBorder":"DCZUA8","filter":"zy22Vh"};